import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-doordash',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>DoorDash icon</title><path d="M23.071 8.409a6.09 6.09 0 00-5.396-3.228H.584A.589.589 0 00.17 6.184L3.894 9.93a1.752 1.752 0 001.242.516h12.049a1.554 1.554 0 11.031 3.108H8.91a.589.589 0 00-.415 1.003l3.725 3.747a1.75 1.75 0 001.242.516h3.757c4.887 0 8.584-5.225 5.852-10.413"/></svg>`,
    styles: []
})
export class SimpleIconsDoordashComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FF3008';
    @Input() className: string = 'simple-icons-doordash'
    constructor() {}
    ngOnInit(): void {}
}
